import useDrivers from '@/compositions/useDrivers'
import useForm from '@/compositions/useForm'
import { required } from '@/utils/validations'
import useRequest from '@/compositions/useRequest'

export default {
  props: {
    order: Object,
  },
  setup(props, context) {
    const { emit } = context
    const { $store } = context.root

    const { loadingDrivers, drivers } = useDrivers(context)

    const { instance, driver } = props.order
    const instanceId = instance ? instance.id : null
    const currentDriver = driver ? { text: driver.name, value: driver.id } : {}

    const {
      formData, validate, $errors, getData,
    } = useForm({
      fields: {
        driverId: { default: currentDriver.value, validations: { required } },
      },
    })

    const changeDriverRequest = useRequest({
      context,
      successMessage: 'Водитель обновлен!',
      request: data => $store.dispatch('orders/update', { orderId: props.order.id, data }),
    })

    const submitChangeDriver = async () => {
      if (!validate()) return
      if (!instanceId) return
      const data = { driverId: formData.driverId.value }
      await changeDriverRequest.makeRequest(data)
      emit('success')
    }

    return {
      drivers,
      loadingDrivers,
      formData,
      validate,
      $errors,
      getData,
      submitChangeDriver,
    }
  },
}
